module.exports = __webpack_public_path__ + "a67682b7b87727a497705a3c7c030660.pdf";